/**
 * Dynamite override for the UGC Home Page carousel header.
 *
 * Realm 1 (SFRA) Dynamite spec: same metrics as Garage, but the heading/CTA use
 * the regular cut of AzoSans (weight 400) with no casing change. Only the deltas
 * live here; the shared metrics are in
 * theme/components/project/ugc-carousel-header.js.
 */
export default {
    baseStyle: {
        title: {
            fontFamily: 'AzoSans',
            fontWeight: 'normal',
            textTransform: 'none'
        },
        seeAll: {
            fontFamily: 'AzoSans',
            fontWeight: 'normal',
            textTransform: 'none'
        }
    }
}
